export const MAX_FILE_SIZE = 10 * 1024 * 1024;

// 上限下限が存在しない場合は、-1000000, 1000000を設定する
export const TEMPERATURE_MINIMUM = -1000000;
export const TEMPERATURE_MAXIMUM = 1000000;

export const MAX_LIMIT = 99999;

// エクスポート: ファイル形式
export const EXPORT_FILE_FORMAT_EXCEL = 'excel';
export const EXPORT_FILE_FORMAT_CSV = 'csv';
export const EXPORT_FILE_FORMAT_CREATE_SIMPLE = 'create_simple';
export const EXPORT_FILE_FORMAT_ALL_CHAPTERS = 'all_chapters';

// エクスポート: 標準CSV エクスポート形式
export const EXPORT_FORMAT_CSV_SDS = 'sds';
export const EXPORT_FORMAT_CSV_PRODUCT = 'product';
export const EXPORT_FORMAT_CSV_CHEMICAL = 'chemical';

// タグなしで利用するダミーID
export const NO_TAG_ID = -1;

// 部署なしで利用するセンチネル値
export const NO_DEPARTMENT_ID = 'NO_DEPARTMENT';
